// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__3X+Zv","contacts":"Footer_contacts__dkOON","contact_title":"Footer_contact_title__DkDFC","contact_mail":"Footer_contact_mail__471KV"};